const IconSchool = () => {
    return (
        <svg
            width="170"
            height="170"
            viewBox="0 0 170 170"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 37.022H58.3333V58.3553H37V37.022Z"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 37.022H58.3333V58.3553H37V37.022Z"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 111.688H58.3333V133.022H37V111.688Z"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 111.688H58.3333V133.022H37V111.688Z"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M111.667 37.022H133V58.3553H111.667V37.022Z"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M111.667 37.022H133V58.3553H111.667V37.022Z"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37 90.3555H79.6667V101.022"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M37 90.3555H79.6667V101.022"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M101 101.022V133.022H133V101.022H122.333"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M101 101.022V133.022H133V101.022H122.333"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M79.6669 122.355V133.022"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M79.6669 122.355V133.022"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M79.6665 37.022V69.022H90.3332"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M79.6665 37.022V69.022H90.3332"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M111.667 79.6889H133"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M111.667 79.6889H133"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 42.3553V15.6886C5 9.7976 9.77563 5.02197 15.6667 5.02197H42.3333"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5 42.3553V15.6886C5 9.7976 9.77563 5.02197 15.6667 5.02197H42.3333"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M127.667 5.02197H154.333C160.224 5.02197 165 9.7976 165 15.6886V42.3553"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M127.667 5.02197H154.333C160.224 5.02197 165 9.7976 165 15.6886V42.3553"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M165 127.688V154.355C165 160.246 160.225 165.022 154.334 165.022H127.667"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M165 127.688V154.355C165 160.246 160.225 165.022 154.334 165.022H127.667"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M42.3333 165.022H15.6667C9.77563 165.022 5 160.246 5 154.355V127.688"
                stroke="currentColor"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M42.3333 165.022H15.6667C9.77563 165.022 5 160.246 5 154.355V127.688"
                stroke="currentColor"
                stroke-opacity="0.8"
                strokeWidth="8.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconSchool;
